// Real client reviews (Google Reviews) - verbatim from screenshots
export const REVIEWS = [
  {
    name: "Solange Rizza",
    when: "il y a 2 mois",
    stars: 5,
    role: "Club de retraités",
    text: "My animation a animé notre après midi festif du club de retraités de notre résidence. Yannick est très professionnel et sympathique. Il sait s'adapter aux personnes et met une bonne ambiance. Merci à lui pour ce bon après midi.",
  },
  {
    name: "Amélie De Sa",
    when: "il y a 3 mois",
    stars: 5,
    role: "Anniversaire 18 ans",
    text: "DJ très professionnel, respectueux des souhaits de musique... bonne ambiance... matériel de très haute qualité, tout est mis en œuvre pour réussir l'événement, pour nous c'était les 18 ans de notre fille et soirée parfaite grâce à Yannick. Je recommande vivement, allez-y les yeux fermés.",
  },
  {
    name: "Laetitia Hennebique",
    when: "il y a 3 mois",
    stars: 5,
    role: "Soirée privée",
    text: "DJ très professionnel, ponctuel et à l'écoute. Nous le recommandons vivement pour une soirée ou un mariage mémorable ! Absolument parfait, playlist adaptée à nos goûts, très bonne ambiance du début à la fin.",
  },
  {
    name: "Marie-Charlotte Esteves",
    when: "il y a 2 mois",
    stars: 5,
    role: "Événement privé",
    text: "Nous avons déjà fait venir ce DJ pour l'une de nos soirées et nous en sommes ravis ! C'est une très bonne personne, professionnelle, à l'écoute et toujours avec une super énergie. Son équipement est de grande qualité : très bonnes lumières, machine à fumée, son impeccable... tout était réuni pour une ambiance au top. Il a largement contribué à la réussite de la soirée et nous le recommandons sans hésiter pour tous types d'événements !",
  },
  {
    name: "Julien Piard",
    when: "il y a 2 mois",
    stars: 5,
    role: "Soirée événementielle",
    text: "Excellente prestation du DJ : ponctuel, organisé et très attentif à nos demandes. Le son et les enchaînements étaient parfaits, l'ambiance était au rendez-vous. Un vrai pro que je recommande sans hésiter.",
  },
];
